import Vue from 'vue';
import Vuetify from 'vuetify/lib';

import ICamera from '@/icons_2/ICamera'
import IDoor from '@/icons_2/IDoor'
import IHome from '@/icons_2/IHome'
import ISystem from '@/icons_2/ISystem'
import IList from '@/icons_2/IList'
import INetwork from '@/icons_2/INetwork'
import ISafety from '@/icons_2/ISafety'
import IRoundedPlus from '@/icons_2/IRoundedPlus'
import IEdit from '@/icons_2/IEdit'
import ITrash from '@/icons_2/ITrash'
import IEye from '@/icons_2/IEye'
import IEyeOff from '@/icons_2/IEyeOff'
import ICalendar from '@/icons_2/ICalendar'
import ITime from '@/icons_2/ITime'
import ICheckpoint from '@/icons_2/ICheckpoint'
import IGate from '@/icons_2/IGate'
import IDiscard from '@/icons_2/IDiscard'
import IFileDownload from '@/icons_2/IFileDownload'
import ILogo from '@/icons_2/ILogo'

Vue.use(Vuetify);

export default new Vuetify({
    iconfont: 'mdiSvg',
    theme: {
    themes: {
      light: {
          primary: '#207EA9',
          secondary: '#424242',
          accent: '#82B1FF',
          error: '#FF5252',
          info: '#2196F3',
          success: '#4CAF50',
          warning: '#FFC107',
      },
    },
    },
    icons: {
        values: {
            icon_logo: {
                component: ILogo,
            },
            icon_camera: {
                component: ICamera,
            },
            icon_door: {
                component: IDoor,
            },
            icon_home: {
                component: IHome,
            },
            icon_system: {
                component: ISystem,
            },
            icon_list: {
                component: IList,
            },
            icon_network: {
                component: INetwork,
            },
            icon_safety: {
                component: ISafety,
            },
            icon_rounded_plus: {
                component: IRoundedPlus,
            },
            icon_edit: {
                component: IEdit,
            },
            icon_trash: {
                component: ITrash,
            },
            icon_eye: {
                component: IEye,
            },
            icon_eye_off: {
                component: IEyeOff,
            },
            icon_calendar: {
                component: ICalendar,
            },
            icon_time: {
                component: ITime
            },
            icon_checkpoint: {
                component: ICheckpoint
            },
            icon_gate: {
                component: IGate
            },
            icon_cross: {
                component: IDiscard
            },
            icon_file_download: {
                component: IFileDownload
            }
        }
    }
});
